import $ from "jquery";
window.jQuery = window.$ = $

import {o_promise_core_ready} from './core';

o_promise_core_ready.then( () => {
    //TODO Remove this portion of code to a separate file
    let e_loading_screen = document.querySelector('.loading-screen');
    e_loading_screen.addEventListener('transitionend', function() {
        this.remove();
    });
    e_loading_screen.style.opacity = 0;
    
    //TODO Remove this portion of code to a separate file
    document.querySelector('.collapsable-toogle').onclick = () => {
        document.querySelector('#header').classList.toggle('opened');
    
        let b_state = document.querySelector('#header').classList.contains('opened');
        
        document.documentElement.style.setProperty('--sub-header-height', b_state ? '42px' : '');
    }
} ).catch((err) => {
    console.log('Falha ao carregar página');
    console.error(err);
});

//TODO Revisit this
// window.addEventListener("load", () => {
//     if ("serviceWorker" in navigator) {
//         navigator.serviceWorker.register('service-worker.js');
//     }
// });